module.exports = __webpack_public_path__ + "static/media/loading.35b947f5.gif";